<template>
    <div class="child-account-login">
        <el-form ref="form" :model="form" :rules="rules" class="bind-phone">
            <el-form-item prop="main_account">
                <el-input
                    v-model.trim="form.main_account"
                    placeholder="请输入主账号"
                    @keyup.enter.native="submit"
                ></el-input>
            </el-form-item>
            <el-form-item prop="account">
                <el-input
                    v-model.trim="form.account"
                    placeholder="请输入子账号"
                    @keyup.enter.native="submit"
                ></el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input
                    v-model="form.password"
                    type="password"
                    placeholder="请输入密码"
                    show-password
                    @keyup.enter.native="submit"
                ></el-input>
            </el-form-item>
        </el-form>
        <el-button
            class="width-100 child-account-login__submit"
            type="primary"
            :loading="loading"
            @click="submit"
        >
            登录
        </el-button>
        <p class="text-center child-account-login__back">
            <a href="javascript:;" class="child-account-login__back-link" @click.prevent="$emit('back')">返回账号登录</a>
        </p>
    </div>
</template>

<script>
export default {
    name: 'ChildAccountLogin',
    props: {
        exData: {
            type: [String, Object],
            default: '',
        },
    },
    data() {
        return {
            loading: false,
            form: {
                main_account: '',
                account: '',
                password: '',
            },
            rules: {
                main_account: [
                    { required: true, message: '请输入主账号', trigger: 'blur' },
                ],
                account: [
                    { required: true, message: '请输入子账号', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
            },
        }
    },
    methods: {
        reset() {
            this.form = { main_account: '', account: '', password: '' }
            this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate()
            })
        },
        async submit() {
            this.$refs.form.validate(async valid => {
                if (!valid) return
                sessionStorage.removeItem('sign')
                this.loading = true
                try {
                    const uploadData = {
                        main_account: this.form.main_account,
                        account: this.form.account,
                        password: this.form.password,
                    }
                    const { code, data, msg } = await this.$fetch('/tool/members/child-account-login', uploadData, 'post')
                    if (code === 0) {
                        this.$store.commit('login', {
                            payload: data,
                            callback: () => {
                                this.$store.dispatch('upDateUser')
                                this.$bus.emit('handleLogin')
                                this.$emit('success', this.exData)
                            },
                        })
                    } else {
                        if (msg === '账号或密码不正确') {
                            setTimeout(() => {
                                this.$emit('forget')
                            }, 1400)
                        }
                    }
                } finally {
                    this.loading = false
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.child-account-login {
    padding: 4px 0 8px;

    &__submit {
        margin-top: 6px;
    }

    &__back {
        margin-top: 14px;
        margin-bottom: 0;
    }

    &__back-link {
        color: #999;
        font-size: 13px;
        text-decoration: none;

        &:hover {
            color: #666;
        }
    }
}
</style>
